import wixWindow from 'wix-window';
const viewMode = wixWindow.viewMode;

$w.onReady(async function () {
	init();
	const initialData = await $w('#albumsGallery').onReady();
	refreshAlbumData(initialData);
	if (viewMode === "Preview") {
		$w('#albumsGallery').onRefreshHappened((data) => {
			refreshAlbumData(data);
		});
		$w('#albumsGallery').reportPageLoaded();
	}
});

function init() {
	$w('#albumNameBox').hide && $w('#albumNameBox').hide();

	$w('#backButtonBox').show && $w('#backButtonBox').show();
	$w('#accountNavBar1').show && $w('#accountNavBar1').show();
}

async function refreshAlbumData({albumData, sets}) {
	try {
		console.log({albumData})
		if (!albumData || !sets) {
			return;
		}
		$w('#backButton').link = albumData.listsBackLink || '/';
		if(albumData.allowSelections) {
			$w('#accountNavBar1').show();
		} else {
			$w('#accountNavBar1').hide();
		}
	} catch (e) {
		console.warn('Error_On_Page', e);
	}
}